var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body privacy",domProps:{"innerHTML":_vm._s(_vm.privacy)}})
}
var staticRenderFns = []

export { render, staticRenderFns }